<template>
  <div class="logistics-big-box">
    <div class="logistics-main">
      <div class="lable">物流信息</div>
      <div class="logistics-list" v-if="logisticsInfo.ContentList">
        <div class="logistics-left">
          <img src="../../assets/icon/blue_wl.png" alt="">
          <p>
            <span>{{logisticsInfo.LogisticsCompanyName}}</span>
            <span>运单号：{{logisticsInfo.LogisticsCode}}</span>
          </p>
        </div>
        <div class="logistics-right">
          <ul>
            <li v-for="(item, index) in logisticsInfo.ContentList" :key="index">
              <span class="time">{{item.Time}}</span>
              <i class="none-icon"></i>
              <span class="tips">{{item.Description}}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="logistics-box" v-else>
        <img src="../../assets/icon/wl_icon.png" alt="">
        <span>暂无物流信息</span>
      </div>
    </div>
  </div>
</template>
<script>
import {
  UserOrderLogistics, // 订单物流
} from '../../api/api'
export default {
  name: 'logistics',
  data(){
    return{
      logisticsInfo: {}
    }
  },
  created(){
    this.getUserOrderLogistics()
  },
  methods:{
    getUserOrderLogistics(){
      let params = {
        orderNo: this.$route.query.orderNo
      }
      UserOrderLogistics(params).then(res => {
        if(res.data.success){
          this.logisticsInfo = res.data.response || {}
        } else{
          this.$message.error(res.data.msg)
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.logistics-big-box{
  padding-bottom: 40px;
}
.logistics-main{
  width: 1200px;
  margin: 0 auto;
  background: #ffffff;
  padding: 10px 20px;
  border-radius: 10px;
}
.lable{
  font-size: 18px;
  line-height: 25px;
  font-weight: bold;
  color: #333333;
  margin: 20px 0;
  padding: 5px;
  text-align: left;
  background: #f4f4f4;
}
.logistics-list{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  .logistics-left{
    width: 400px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    img{
      width: 64px;
      height: 64px;
    }
    p{
      margin-left: 10px;
    }
    span{
      display: block;
      text-align: left;
      margin-bottom: 10px;
    }
  }
  .logistics-right{
    flex: 1;
    text-align: left;
    li{
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      padding-bottom: 20px;
      position: relative;
      span,i{
        display: inline-block;
        line-height: 20px;
      }
      .time{
        width: 180px;
        text-align: right;
      }
      .tips{
        flex: 1;
      }
      .none-icon{
        margin: 0 16px;
        display: inline-block;
        width: 15px;
        height: 15px;
        border-radius: 15px;
        background: #d8d8d8;
        position: relative;
        z-index: 10;
      }
    }
    li::before{
      content: '';
      position: absolute;
      border-left: 1px solid #d8d8d8;
      height: 100%;
      left: 203.455px;
    }
    li:first-child .none-icon::before{
      content: url(../../assets/icon/blue_tick.png);
      width: 25px;
      height: 25px;
      position: relative;
      top: -4px;
      left: -4.5px;
    }
  }
}
.logistics-box{
  display: flex;
  justify-content: center;
  align-items: center;
  img{
    width: 64px;
    height: 64px;
  }
  span{
    display: inline-block;
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    line-height: 64px;
    margin-left: 16px;
  }
}
</style>